export const CUSTOMER_CHAINS = ['Ica', 'Axfood', 'Coop', 'Foodservice'] as const;

export type CustomerChain = typeof CUSTOMER_CHAINS[number];

export interface CustomerCategory {
  name: string;
  packageMark: string;
}

export interface CustomerContact {
  id: string;
  chain: CustomerChain;
  name: string;
  email: string;
  phone: string;
  address: string;
  categories: CustomerCategory[];
  note: string;
}

export function customerChainOf(value: string): CustomerChain | '' {
  const key = value.trim().toLocaleLowerCase('sv');
  if (key === 'ica') return 'Ica';
  if (key === 'axfood') return 'Axfood';
  if (key === 'coop') return 'Coop';
  if (key === 'foodservice') return 'Foodservice';
  return '';
}
